module.exports = __webpack_public_path__ + "static/media/intro.48dfb0d2.mp3";